import Api from '@/api/Api'

class Category extends Api {
  protected resource = 'browse-categories'

  public async show<T>(resourceKey: number | string): Promise<T> {
    const { data, error, response } = await this.fetch(`${this.resource}/${resourceKey}`).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async browse<T>() {
    const { data, error, response } = await this.fetch<T>(this.resource).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async browseFeatured<T>() {
    const { data, error, response } = await this.fetch<T>(`${this.resource}/featured`).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }
}

export default new Category()
